import AddToGooglePay from '../../../../banking/components/cards/AddToGooglePay';

const GooglePayScreen = () => {
    return <AddToGooglePay />;
};

export default GooglePayScreen;
